import { registerResourceSourceDef } from '../structs/resource-source';
registerResourceSourceDef({
    ignoreRange: true,
    parseMeta: function (raw) {
        if (Array.isArray(raw)) {
            return raw;
        }
        else if (Array.isArray(raw.resources)) {
            return raw.resources;
        }
        return null;
    },
    fetch: function (arg, successCallback) {
        successCallback({
            rawResources: arg.resourceSource.meta
        });
    }
});
